module.exports = __webpack_public_path__ + "static/media/tuilogo.7acc3c6b.svg";